<template>
  <v-col>
    <v-row>
      <v-col class="text-subtitle-2 gray--text text--lighten-1">
        Distância pupilar
      </v-col>
    </v-row>

    <v-row>
      <v-combobox
        v-model="pupillaryDistanceRightEye"
        placeholder=" "
        label="Olho direito"
        class="pr-1"
        dense
        outlined
        hide-details
        :items="pupillaryDistanceFacilitators"
        background-color="white"
        :disabled="disabled"
        @input="handleChange"
      />

      <v-combobox
        v-model="pupillaryDistanceLeftEye"
        placeholder=" "
        label="Olho esquerdo"
        class="pl-1"
        dense
        outlined
        hide-details
        :items="pupillaryDistanceFacilitators"
        background-color="white"
        :disabled="disabled"
        @input="handleChange"
      />
    </v-row>
  </v-col>
</template>

<script>
  import SAVE_PUPILLARY_DISTANCE from "@/graphql/glasses_prescription/save_pupillary_distance.gql";

  export default {
    name: "GlassesPrescriptionFormPupillaryDistance",
    props: {
      attendance: Object,
      glassesPrescriptionId: String,
      pupillaryDistance: Object,
      refreshGlassesPrescription: Function,
      facilitators: Array,
      disabled: {
        type: Boolean,
        default: false,
      },
     handleChange: Function,
    },
    data() {
      return {
        pupillaryDistanceRightEye: "",
        pupillaryDistanceLeftEye: "",
      };
    },
    created: function() {
      this.debouncedSavePupillaryDistance = this.lodash.debounce(
        this.savePupillaryDistance,
       900000 
      );
    },
    mounted() {
      this.loadPupillaryDistance();
    },
    computed: {
      pupillaryDistanceFacilitators() {
        let facilitator = this.lodash.find(this.facilitators, {
          facilitatorType: "pupillary_distance",
        });

        if (facilitator) {
          return facilitator.values;
        }

        return [];
      },
    },

    methods: {
      loadPupillaryDistance() {
        if (this.pupillaryDistance) {
          this.pupillaryDistanceLeftEye = this.pupillaryDistance.leftEye;
          this.pupillaryDistanceRightEye = this.pupillaryDistance.rightEye;
        } else {
          this.pupillaryDistanceLeftEye = this.lodash.first(this.pupillaryDistanceFacilitators);
          this.pupillaryDistanceRightEye = this.lodash.first(
            this.pupillaryDistanceFacilitators
          );

          this.debouncedSavePupillaryDistance();
        }
      },
     async savePupillaryDistance() {
        try {
          if (this.disabled) return;
          await this.apolloMutate({
             mutation: SAVE_PUPILLARY_DISTANCE,
             variables: {
              glassesPrescriptionId: this.glassesPrescriptionId,
              leftEye: this.pupillaryDistanceLeftEye,
              rightEye: this.pupillaryDistanceRightEye,
            },
          });
        } catch (error) {
          console.error('Erro ao salvar:', error);
        }
     },
    }
  };
</script>

<style lang="scss" scoped></style>
